export default __webpack_public_path__ + "static/img-finish-products-a85dc3634f19e4635cbfe97ede1ff9f4.webp";